<h2
	id="order-confirm-title"
	class="flex w-full items-center justify-center gap-0.5 text-sm font-bold text-gray-900"
	data-cy="order-confirm-title">
	<span>{{ titlePrefix() }}&nbsp;</span>
	<span
		[class.text-red-500]="summary().side === OrderSide.Sell"
		[class.text-green-500]="summary().side === OrderSide.Buy"
		>{{ summary().sideText }}</span
	>
</h2>
@if (summary().orderConfirmationEnabled) {
	<div
		class="flex flex-col divide-y divide-stroke-100 text-3.25 font-medium text-gray-900"
		data-cy="order-confirm-body">
		<div class="flex h-9 w-full items-center justify-between gap-2">
			<span>نماد</span>
			<span class="font-medium" data-cy="order-confirm-symbol">{{ summary().symbolName }}</span>
		</div>

		<div class="flex h-9 w-full items-center justify-between gap-2">
			<span>تعداد</span>
			<ui-number data-cy="order-confirm-quantity" [value]="summary().quantity" />
		</div>

		<div class="flex h-9 w-full items-center justify-between gap-2">
			<span>قیمت</span>
			<div class="flex items-center gap-1">
				<ui-number format="1.0-0" data-cy="order-confirm-price" [value]="summary().price" />
				<span>ریال</span>
			</div>
		</div>

		<div class="flex h-9 w-full items-center justify-between gap-2">
			<span>ارزش</span>
			<div class="flex items-center gap-1">
				<ui-number format="1.0-0" data-cy="order-confirm-value" [value]="summary().totalValue" />
				<span>ریال</span>
			</div>
		</div>
	</div>

	@if (summary().totalValue > 0) {
		<p class="pb-2 text-2.75 font-medium text-gray-700" data-cy="order-confirm-value-words">
			({{ summary().totalValue | numberToPersianWords }})
		</p>
	}
}
@if (isOrderSplitting()) {
	<div
		class="flex flex-col rounded-2.5 p-3 gap-1 bg-blue-050 mb-2"
		[class.mt-2]="!summary().orderConfirmationEnabled">
		<div class="flex items-center gap-1.5">
			<ui-icon width="20" height="20" class="shrink-0 text-blue-500" aria-hidden="true" iconName="info-box" />
			<span class="font-bold text-3.25 text-gray-900"
				>درخواست شما، در قالب {{ orderSplittedCount() }} سفارش ارسال خواهد شد.</span
			>
		</div>

		<div class="flex flex-col text-3.25 font-medium text-gray-900">
			<div class="flex w-full items-center justify-between gap-2 py-1">
				<span>حجم سفارش شما</span>
				<ui-number format="1.0-0" [value]="summary().quantity" />
			</div>
			<ui-divider />
			<div class="flex w-full items-center justify-between gap-2 py-1">
				<span>حداکثر حجم مجاز در هر سفارش</span>
				<ui-number format="1.0-0" [value]="summary().maxVolume" />
			</div>
		</div>
	</div>
}
<div class="flex w-full gap-2" data-cy="order-confirm-actions">
	<ui-button
		type="button"
		class="min-w-0 flex-1"
		variant="green"
		size="md"
		extraButtonClasses="w-full"
		data-cy="order-confirm-submit"
		[label]="confirmLabel()"
		[disabled]="loading()"
		[loading]="loading()"
		(click)="confirmed.emit()" />
	<ui-button
		type="button"
		class="min-w-0 flex-1"
		variant="mute"
		size="md"
		extraButtonClasses="w-full"
		data-cy="order-confirm-cancel"
		label="انصراف"
		[disabled]="loading()"
		(click)="cancelled.emit()" />
</div>
